import { Logo } from 'foundations-components/transitional/components/Logo';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import UILink from 'UIComponents/link/UILink';
import { getIsChatSpot, getIsConnect, getIsEngageAI } from '../../utils/urls';
// @ts-expect-error not converted to TS
import ImageUrl from '../../images/imageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderWithLogo({
  children,
  logoWidth = '128px',
  logoAlignment = 'start',
  logoPadding = '1000'
}) {
  const isChatSpot = getIsChatSpot();
  const isConnect = getIsConnect();
  const isEngageAI = getIsEngageAI();
  const renderLogo = () => {
    if (isChatSpot) {
      return /*#__PURE__*/_jsx(Image, {
        src: ImageUrl.chatSpotLogo,
        alt: "ChatSpot Logo",
        inlineSize: logoWidth,
        marginBlockStart: "400"
      });
    } else if (isConnect) {
      return /*#__PURE__*/_jsx(Image, {
        src: ImageUrl.connectLogo,
        inlineSize: logoWidth,
        alt: "Connect Logo",
        marginBlockEnd: "200",
        marginBlockStart: "400"
      });
    } else if (isEngageAI) {
      return /*#__PURE__*/_jsx(Image, {
        src: ImageUrl.engageAILogo,
        inlineSize: logoWidth,
        alt: "Engage.AI Logo",
        marginBlockEnd: "200",
        marginBlockStart: "400"
      });
    } else {
      return /*#__PURE__*/_jsx(UILink, {
        href: "https://www.hubspot.com",
        children: /*#__PURE__*/_jsx(Logo, {
          name: "hubspot-wordmark",
          width: logoWidth,
          alt: "Hubspot Homepage",
          marginBlockEnd: "200",
          marginBlockStart: "400"
        })
      });
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    padding: logoPadding,
    alignItems: logoAlignment,
    alignSelf: logoAlignment,
    children: [renderLogo(), /*#__PURE__*/_jsx("div", {
      children: children
    })]
  });
}